import dayjs from "dayjs";
import { useMemo } from "react";
import useSWR from "swr";
import { getRequest } from "../api/config";
import { roaming_document_count } from "../api/api";

const DAYS = 9
export const useExpiringDocuments = () => {
  const date = dayjs().subtract(DAYS, "day").format("YYYY-MM-DD");
  const expiringCheckParams = useMemo(
    () => ({
      date_start: date,
      date_end: date,
      status: 15,
    }),
    [date],
  );
  const { data: expiringCount = 0 } = useSWR(
    { url: roaming_document_count, params: expiringCheckParams },
    getRequest,
  );
  const hasExpiringDocuments = (expiringCount ?? 0) > 0;

  return { hasExpiringDocuments };
};
